// @ts-nocheck
/* eslint-disable */

"use client";

import { useEffect, useLayoutEffect, useMemo } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import { gsap } from "gsap";
import onAppearAnimations from "@/lib/helpers/animations";
import { useGlobalContext } from "@/lib/globalContext";

const NavigationEvents: any = ({
  translatedURI,
  acf,
}: {
  translatedURI: Record<string, string>;
  acf?: Record<string, string>;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { translatedUri, setTranslatedUri } = useGlobalContext();
  useEffect(() => {
    if (JSON.stringify(translatedUri) !== JSON.stringify(translatedURI)) {
      setTranslatedUri(translatedURI);
    }
  }, [translatedURI]);

  useLayoutEffect(() => {
    onAppearAnimations();

    if (acf) {
      gsap.killTweensOf("#masthead");

      document.documentElement.classList.remove(`style-light`, `style-dark`);
      document.documentElement.classList.remove(`header-absolute`);

      if (acf.page_style) {
        document.documentElement.classList.add(`style-${acf.page_style}`);
      }
      if (acf.header_absolute) {
        document.documentElement.classList.add(`header-absolute`);

        gsap.timeline({
          scrollTrigger: {
            trigger: "#masthead",
            start: "+=10",
            end: "+=99999999",
            toggleClass: "scrolled",
          },
        });
      }
    }

    //anchors by slug
    if (location) {
      const hash = location.pathname.slice(0, -1).split("/").pop();
      if (hash && document.getElementById(hash)) {
        document.getElementById(hash).scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center",
        });
      }
    }
  }, []);

  // useEffect(() => {
  //   document.documentElement.classList.remove("page-loading");
  //   const url = `${pathname}?${searchParams}`;

  //   console.log("event", url);

  //   return () => {
  //     console.log("return event");
  //     document.documentElement.classList.add("page-loading");
  //   };
  // }, [pathname, searchParams]);

  return null;
};
export default NavigationEvents;
